import { useEffect } from 'react'

/**
 * A Script injection specific to `v4` customer
 * @description
 * Adds script to head element if customer is `v4`
 * @todo This is atypical to the default settings of the application
 * @todo consider addiing this in Composer and following patterns in `AirfindAd`
 * @todo consider other various tracking methods `gtm` `reactga4` for global migration
 */
const GlassBox = ({ version }) => {
  useEffect(() => {
    if (version === 'v4') {
      const script = document.createElement('script')
      script.id = '_cls_detector'
      script.src = 'https://cdn.glassboxcdn.com/trac/tbv/detector-dom.min.js'
      document.head.appendChild(script)
    }
  }, [])

  return null
}

export default GlassBox



// WEBPACK FOOTER //
// ./src/components/GlassBox/index.js